import React from "react";
import { VodContentReport } from "../../../../../models/epg/Models";
import Card from "../../../../../components/themed/Card";

interface ContentStatsProps{
    contentReport: VodContentReport
}

const ContentStats = ({ contentReport }: ContentStatsProps) => {
    const { series, seasons, episodes, standaloneItems } = contentReport;
    const entries = Object.entries({ series, seasons, episodes, standalone: standaloneItems });

    return (
        <Card className="p-5 flex flex-col justify-between">
            <div>
                <div className="grid grid-cols-2 gap-4 py-5">
                    {
                        entries.map((entry) => (
                            <div key = {entry[0]} className="p-5 shadow-md bg-light dark:!bg-brand-800 rounded-lg">
                                <div className="flex flex-col">
                                    <p className="text-md font-bold">{`${entry[0][0].toUpperCase()}${entry[0].substring(1)}`}</p>
                                    <p className="text-2xl font-bold text-gray-500">{new Intl.NumberFormat("en-US").format(entry[1])}</p>
                                </div>
                            </div>
                        ))
                    }
                </div>
            </div>
            <div>
                <div className="grid grid-cols-2 gap-4 py-5">
                    <div className="p-5 flex flex-row justify-between">
                        <p className="text-gray-500 font-bold text-lg">Total Hours</p>
                        <p className="font-bold text-gray-500 text-lg">{new Intl.NumberFormat("en-US").format(Math.round(contentReport.totalRunTime / 60 / 60))}</p>
                    </div>
                    <div className="p-5 flex flex-row justify-end">
                        <a
                            href="/api/vod/content/summary/csv"
                            download
                            className="bg-blue-800 dark:bg-indigo-400 text-white shadow-md border p-1 rounded-md"
                        >
                            Export VOD Summary Report
                        </a>
                    </div>
                </div>
            </div>
        </Card>
    );
};

export default ContentStats;
